import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box
} from "@mui/material";
import { t } from "i18next";
import { setMobileButttonBackColor, setMobileCardBorderColor, setMobileCardColor, setMobileTextColor } from '../../utility';

const LocationDistanceDialog = ({
    open,
    onClose,
    onChangeAddresss,
    onConfirm,
    onCancel,

}) => {

    const handleChangeAddress = async () => {
        await onClose();
        onChangeAddresss();
    };
    return (
        <Dialog
            open={open}
            onClose={onCancel}
            PaperProps={{
                sx: {
                    backgroundColor: setMobileCardColor(),
                    color: setMobileTextColor(),
                    borderRadius: "12px",
                    minWidth: "300px",
                    maxWidth: "400px",
                    margin: "16px"
                }
            }}
        >
            <DialogTitle className="head-font" sx={{ textAlign: "center", pb: 1 }}>
                {t("Out of Delivery Area")}
            </DialogTitle>

            <DialogContent sx={{ textAlign: "center", pb: 2 }}>
                <Box sx={{ mb: 2 }}>
                    <Typography className="sub-font" sx={{ mb: 1, fontSize: "16px", lineHeight: 1.4 }}>
                        {t("The address you chose is not within the delivery range, and you can place the order by receiving it.")}
                    </Typography>
                </Box>
            </DialogContent>

            <DialogActions sx={{ justifyContent: "center", gap: 2, p: 2, pt: 0 }}>
                {/* <Button
                    onClick={onCancel}
                    className="head-font"
                    sx={{
                        color: setMobileTextColor(),
                        border: `1px solid ${setMobileCardBorderColor()}`,
                        borderRadius: "8px",
                        padding: "8px 16px",
                        textTransform: "none",
                        minWidth: "100px",
                        '&:hover': {
                            backgroundColor: setMobileCardBorderColor() + '20',
                        }
                    }}
                >
                    {t("Cancel")}
                </Button> */}

                {/* change address */}
                <Button
                    onClick={handleChangeAddress}
                    className="head-font"
                    sx={{
                        color: setMobileTextColor(),
                        border: `1px solid ${setMobileCardBorderColor()}`,
                        borderRadius: "8px",
                        padding: "8px 16px",
                        textTransform: "none",
                        minWidth: "100px",
                        '&:hover': {
                            backgroundColor: setMobileCardBorderColor() + '20',
                        }
                    }}
                >
                    {t("Change Address")}
                </Button>

                <Button
                    onClick={onConfirm}
                    className="head-font"
                    sx={{
                        backgroundColor: setMobileButttonBackColor(),
                        color: setMobileTextColor(),
                        borderRadius: "8px",
                        padding: "8px 16px",
                        textTransform: "none",
                        minWidth: "100px",
                        '&:hover': {
                            backgroundColor: setMobileButttonBackColor() + 'CC',
                        }
                    }}
                >
                    {t("Change To Pickup")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default LocationDistanceDialog;